import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

export default permission => {
	const userPermissions = useSelector(s => s.auth?.user?.permissions);

	const [hasPermission, setHasPermission] = useState(permission === null || permission ? true : false);

	useEffect(() => {
		if (permission !== null)
			setHasPermission(userPermissions.find(x => x.key === permission)?.value || false);
	}, [userPermissions]);

	return hasPermission;
};
